<div>
    <app-data-grid-logs [auditList]="auditLogData"></app-data-grid-logs>
</div>